import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-left" }
const _hoisted_3 = { class: "copyright" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_5 = { class: "footer-right" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://www.elichens.com/" }, "elichens.com"),
  /*#__PURE__*/_createTextVNode(" | "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://www.elichens.com/terms" }, "Terms of service"),
  /*#__PURE__*/_createTextVNode(" | ")
], -1 /* HOISTED */)
const _hoisted_7 = { class: "icon-text" }
const _hoisted_8 = { class: "icon" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "powered" }, "Powered by eLichens' technology", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "Copyright © " + _toDisplayString(_ctx.year) + " eLichens", 1 /* TEXT */),
      _hoisted_4,
      _createElementVNode("span", null, _toDisplayString(_ctx.VERSION), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("span", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, [
          _createElementVNode("img", { src: _ctx.logo }, null, 8 /* PROPS */, _hoisted_9)
        ]),
        _hoisted_10
      ])
    ])
  ]))
}